import React, { useState, useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Title, Tooltip, Legend } from 'chart.js';

// Registrar os componentes necessários do Chart.js
ChartJS.register(ArcElement, Title, Tooltip, Legend);

const DoughnutChart = ({ data, includeKeys, nameMap, title, titleColor, titleFontSize, labelColor, labelFontSize }) => {
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: []
    });

    const prepareChartData = (data, includeKeys, nameMap) => {
        // Lógica de preparação de dados permanece a mesma
        if (!data || typeof data !== 'object') {
            console.error('Os dados fornecidos estão incorretos.');
            return {
                labels: [],
                datasets: []
            };
        }

        const labels = includeKeys.map(key => nameMap[key] || key); // Mapeia nomes personalizados

        const values = includeKeys.map(key => {
            const qtd = data[key]?.qtd;
            return (qtd === null || qtd === undefined) ? 0 : Number(qtd); // Converte null para 0
        });

        return {
            labels: labels,
            datasets: [
                {
                    label: 'Quantidade',
                    data: values,
                    backgroundColor: [
                        'rgba(228, 202, 59, 1)',
                        'rgba(255, 250, 250, 0.6)',
                        'rgba(79, 79, 79, 0.6)',
                        'rgba(255, 255, 255, 1)',
                        'rgba(80, 220, 220, 0.6)',
                        'rgba(160, 80, 255, 0.6)',
                        'rgba(255, 150, 50, 0.6)',
                        'rgba(100, 80, 200, 0.6)',
                        'rgba(250, 70, 180, 0.6)',
                    ],
                    borderWidth: 1
                }
            ]
        };
    };

    useEffect(() => {
        if (data) {
            const chart = prepareChartData(data, includeKeys, nameMap);
            setChartData(chart);
        }
    }, [data, includeKeys, nameMap]);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'right',
                labels: {
                    color: labelColor || '#ccc',
                    font: {
                        size: labelFontSize || 12
                    }
                }
            },
            title: {
                display: true,
                text: title, // Usando o título passado como propriedade
                color: titleColor || '#ccc',
                font: {
                    size: titleFontSize || 14
                }
            }
        }
    };

    return <Doughnut data={chartData} options={options} />;
};

export default DoughnutChart;